import type { JSX, ReactNode } from 'react';

export type BadgeTone = 'neutral' | 'positive' | 'negative' | 'warning' | 'accent';

const toneClasses: Readonly<Record<BadgeTone, string>> = {
  neutral: 'border-border-strong text-ink-muted',
  positive: 'border-positive/40 text-positive',
  negative: 'border-debt/40 text-debt',
  warning: 'border-warning/40 text-warning',
  accent: 'border-accent/40 bg-accent-soft text-accent',
};

export interface BadgeProps {
  readonly tone: BadgeTone;
  readonly children: ReactNode;
}

/** A short state in a pill. The word carries the meaning; the colour only repeats it. */
export function Badge({ tone, children }: BadgeProps): JSX.Element {
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-semibold whitespace-nowrap ${toneClasses[tone]}`}
    >
      {children}
    </span>
  );
}
